import '~assets/stylesheets/common.scss';

import { CART, PRODUCT_DETAILS, PRODUCT_EXPLORER, PURCHASE } from '~constants/WidgetsNames';
import { createCartWidget, createPurchaseWidget, createWidget } from '~helpers';

createWidget(PRODUCT_EXPLORER);
createWidget(PRODUCT_DETAILS);
createPurchaseWidget(PURCHASE);
createCartWidget(CART);
